// extracted by mini-css-extract-plugin
module.exports = {"link":"_8d1436ae","icon":"_4eae0685","placeholder":"_8858d94d"};